import React, { useState } from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { put as putBE } from "utils/api";
import { errorMessage, message } from "actions/message";
import FormikField from "components/forms/formik-field";
import { Formik } from "formik";
import { Tooltip } from "components/ui/tool-tip/tooltip";
import IoIosInformationCircleOutline from "react-icons/lib/io/ios-information";

const PhysicianUpdateForm = ({ patientGuidForJobs, onSuccess }) => {
  const dispatch = useDispatch();
  const [showForm, setShowForm] = useState(false);

  const updatePhysicianDate = async values => {
    dispatch(message("Updating Physician Appointment Date..."));
    try {
      await putBE(`IVR/Work/UpdatePhysicianAppointment`, values);
      dispatch(message("Physician appointment date updated."));
      setShowForm(false);
      if (onSuccess) onSuccess();
    } catch (e) {
      dispatch(errorMessage("Failed to update physician appointment date. Please try again."));
    }
  };

  return (
    <div>
      {!showForm ? (
        <button onClick={() => setShowForm(true)}>Change Physician Appointment Form</button>
      ) : (
        <Formik
          initialValues={{
            patient_guid: patientGuidForJobs,
            physician_date:null
          }}
        >
          {({ values }) => (
            <form>
              <div
                style={{
                  display: "flex",
                  justifyItems: "center"
                }}
              >
                <Tooltip
                  id={`friendly_name`}
                  className="helpful-link-tooltip"
                  effect="solid"
                  message='Will update all patient orders with the status "IVR Pending Work".'
                >
                  <IoIosInformationCircleOutline size="1rem" />
                </Tooltip>
              

<FormikField
                                name="physician_date"
                                label="Next Physicain Appointment Date"
                                type="date"
                            />
                            </div>

              <button
                type="button"
                style={{ marginRight: "10px" }}
                onClick={() => setShowForm(false)}
              >
                Cancel
              </button>
              <button
                type="button"
                disabled={
                  values.physician_date == null
                }
                onClick={() => {
                  updatePhysicianDate(values);
                }}
              >
                Submit
              </button>
            </form>
          )}
        </Formik>
      )}
    </div>
  );
};

PhysicianUpdateForm.propTypes = {
  onSuccess: PropTypes.func,
    patientGuidForJobs: PropTypes.string.isRequired
};

export default PhysicianUpdateForm;
